import { message } from 'ant-design-vue'
import { AxiosRequestHeaders, Method } from 'axios'
import { Request } from './request'

export interface requestOptions {
  loading?: boolean
  mock?: boolean
  error?: boolean
}

export interface requestmethodsOptions {
  url: string
  params?: unknown
  body?: unknown
  options?: requestOptions
  headers?: AxiosRequestHeaders
}

/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 * @param mock 本次是否请求mock而非线上
 * @param error 本次是否显示错误
 */
function request<T>(
  url: string,
  params: unknown,
  method: Method,
  headers?: AxiosRequestHeaders,
  options: requestOptions = { loading: true, mock: false, error: true }
): Promise<T> {
  // 请求前loading
  if (options.loading) message.loading('数据加载中...', 0)

  return new Promise((resolve, reject) => {
    let data = {}

    // get请求使用params字段
    if (method === 'get') data = { params }
    // post请求使用data字段
    if (method === 'post') data = { data: params }
    /*
     * 通过mock平台可对局部接口进行mock设置
     * if (options.mock) url = 'http://www.mock.com/mock/xxxx/api'
     */

    Request.init()
    Request.initInterceptors()

    Request.axiosInstance({
      url,
      method,
      ...data,
      headers
    })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((res: any) => {
        /*
         * 此处作用很大，可以扩展很多功能。
         * 比如对接多个后台，数据结构不一致，可做接口适配器
         * 也可对返回日期/金额/数字等统一做集中处理
         */
        if (res.errcode === 0 || res.success) {
          return resolve(res.data)
        }
        // 通过配置可关闭错误提示
        if (options.error) message.error(res.message, 1.5)
        return reject(res)
      })
      .catch((error) => reject(error))
      .finally(() => {
        message.destroy()
      })
  })
}

// 封装GET请求
function get<T>({
  url,
  params,
  options,
  headers
}: requestmethodsOptions): Promise<T> {
  return request<T>(url, params, 'get', headers, options)
}

// 封装POST请求
function post<T>({
  url,
  body,
  options,
  headers
}: requestmethodsOptions): Promise<T> {
  return request<T>(url, body, 'post', headers, options)
}

function postJSON<T>({
  url,
  body,
  options,
}: requestmethodsOptions): Promise<T> {
  return request<T>(url, body, 'post', {"Content-Type": "application/json"}, options)

}

export default {
  get,
  post,
  postJSON
}
